import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { FaEye, FaPaperPlane } from 'react-icons/fa';
import { useApp } from '../App';
import './FeaturedChef.css';

function FeaturedChef() {
  const [professionals, setProfessionals] = useState([]);
  const [cvItem, setCvItem] = useState(null);
  const [inView, setInView] = useState(false);
  const sectionRef = useRef(null);
  const { setShowRequest, setPreselectedPro } = useApp();

  useEffect(() => {
    axios.get('https://api.hospifylink.com/api/professionals?featured=1')
      .then(r => { 
        if (Array.isArray(r.data)) setProfessionals(r.data.slice(0, 5)); 
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    const node = sectionRef.current;
    if (!node) return;
    if (typeof IntersectionObserver === 'undefined') {
      setInView(true);
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setInView(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  const handleRequest = (pro) => {
    setPreselectedPro(pro);
    setShowRequest(true);
  };

  const safeProfessionals = Array.isArray(professionals) ? professionals : [];

  return (
    <section className={`featuredchef-root ${inView ? 'is-visible' : ''}`} ref={sectionRef}>
      <h2 className="lca-section-title fc-anim fc-title">Featured Professionals</h2>
      <p className="lca-section-sub fc-anim fc-subtitle">
        Meet some of our top-rated hospitality professionals
      </p>

      <div className="featuredchef-grid">
        {safeProfessionals.map((c, i) => (
          <div
            key={c.id}
            className="featuredchef-card fc-anim fc-card"
            style={{ animationDelay: inView ? `${0.25 + i * 0.08}s` : '0s' }}
          >
            <div className="featuredchef-img-wrap">
              <img src={c.image || 'https://via.placeholder.com/400'} alt={c.name} />
              <span className="featuredchef-badge">{c.role}</span>
            </div>
            <div className="featuredchef-body">
              <h3>{c.name}</h3>
              <p className="featuredchef-specialty">{c.specialty}</p>
              <p className="featuredchef-exp">{c.experience} experience</p>
              <div className="featuredchef-btns">
                <button className="featuredchef-view" onClick={() => setCvItem(c)}>
                  <FaEye /> View CV
                </button>
                <button className="featuredchef-request" onClick={() => handleRequest(c)}>
                  <FaPaperPlane /> Request
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {cvItem && (
        <div className="featuredchef-modal" onClick={() => setCvItem(null)}>
          <div className="featuredchef-modal-box" onClick={e => e.stopPropagation()}>
            <img src={cvItem.image} alt={cvItem.name} className="featuredchef-modal-img" />
            <h3>{cvItem.name}</h3>
            <p className="featuredchef-modal-role">
              {cvItem.role} • {cvItem.category} • {cvItem.specialty}
            </p>
            <p className="featuredchef-modal-exp"><b>Experience:</b> {cvItem.experience}</p>
            <p className="featuredchef-modal-bio">{cvItem.bio}</p>
            {cvItem.cv_url && (
              <a href={cvItem.cv_url} target="_blank" rel="noreferrer" className="lca-btn-primary">
                Download CV
              </a>
            )}
            <button
              className="lca-btn-primary"
              style={{ marginTop: 8 }}
              onClick={() => { setCvItem(null); handleRequest(cvItem); }}
            >
              Request This Professional
            </button>
            <button className="featuredchef-modal-close" onClick={() => setCvItem(null)}>
              Close
            </button>
          </div>
        </div>
      )}
    </section>
  );
}

export default FeaturedChef;
